import { useQuery } from '@apollo/client';

import { useEntity } from '@lib/entity';
import { LiveBroadcastEntity } from '@modules/live/entities';
import { GetLiveBroadcastQuery } from '@modules/live/graphql';

import type { GetLiveBroadcastQueryType } from '@modules/types/graphql';

const useLiveBroadcast = () => {
    const queryResult = useQuery<GetLiveBroadcastQueryType>(GetLiveBroadcastQuery);

    const liveBroadcast = useEntity(
        () => new LiveBroadcastEntity(queryResult.data?.getLiveBroadcast ?? null),
        [queryResult.data],
    );

    return {
        liveBroadcast,
        ...queryResult,
    };
};

export { useLiveBroadcast };
